import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Slide.scss';

/*

Transitions its contents either left or right depending on the depth. If the
child changes and the depth increases, the transition will be right to left.

Depth is required and must be a number. Any additional props will be applied to
the outer div container, so a custom className can be added as a styling hook.

Example:
  <SlideTransition depth={path.length} className="items-container">
    ...
  </SlideTransition>

*/
class Slide extends Component {
  static propTypes = {
    depth: PropTypes.number,
    name: PropTypes.string,
  };

  static defaultProps = {
    name: 'Slide',
  };

  constructor(props) {
    super(props);

    this.state = { direction: 'right' };
  }

  componentWillReceiveProps(newProps) {
    const direction = newProps.depth > this.props.depth ? 'right' : 'left';
    this.setState({ direction });
  }

  render() {
    const { name } = this.props;
    const outerProps = {
      className: `${name}-outer-wrapper ${this.props.className}`,
    };

    return (
      <div {...outerProps}>
        <div
          className={`${name}-inner-wrapper`}
          ref={(node) => (this.inner = node)}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default Slide;
